import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineMail,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col xs={12} md={6} className="footer-copywright order-2 order-md-1">
          <h3>Copyright © {year}</h3>
        </Col>
        <Col xs={12} md={6} className="footer-body order-1 order-md-2">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/LautaroPena02"
                style={{ color: "#c9d1d9" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>
                        <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/lautaropenadev/"
                style={{ color: "#c9d1d9" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="mailto:lautaropena99@gmail.com"
                style={{ color: "#c9d1d9" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiOutlineMail />
              </a>
            </li>

          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
